if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          shareButton: this.querySelector('button'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };

        if (!this.elements.shareButton) return;

        this.urlToShare = this.elements.urlInput?.value || document.location.href;
        if (navigator.share) {
          this.elements.shareButton.addEventListener('click', () => this.share());
        } else {
          this.elements.shareButton.addEventListener('click', () => this.copyToClipboard());
        }
      }

      share() {
        navigator.share({ url: this.urlToShare, title: document.title }).catch(() => undefined);
      }

      copyToClipboard() {
        if (!this.elements.urlInput) return;
        this.elements.urlInput.select();
        navigator.clipboard?.writeText(this.elements.urlInput.value).then(() => this.showMessage());
      }

      showMessage() {
        if (!this.elements.successMessage) return;
        this.elements.successMessage.removeAttribute('hidden');
        window.clearTimeout(this.hideMessageTimer);
        this.hideMessageTimer = window.setTimeout(() => {
          this.elements.successMessage.setAttribute('hidden', '');
        }, 2000);
      }
    }
  );
}
